import { render, staticRenderFns } from "./ItemEmptyNoneLayout.vue?vue&type=template&id=238c88e3&scoped=true&"
import script from "./ItemEmptyNoneLayout.vue?vue&type=script&lang=js&"
export * from "./ItemEmptyNoneLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c88e3",
  null
  
)

export default component.exports